export const JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME =
	'jiraEditionAwarenessForStandardToPremium' as const;
